import React from 'react';
import Helmet from "react-helmet";

class Seo extends React.Component{

    render(){

      var title = this.props.info.title;
      var description = this.props.info.description;


      return (
        <span>
          <Helmet
                    htmlAttributes={{lang: "en", amp: undefined}} // amp takes no value
                    title={title}
                    titleAttributes={{itemprop: "name", lang: "en"}}
                    meta={[
                        {name: "description", content: description},
                        {property: "og:type", content: "article"}
                    ]}
                    script={[ {type: "application/ld+json", innerHTML: ` {"@context" : "https://schema.org",
  "@type" : "Organization",
  "name"  : "SportsEtech",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Dubai, UAE",
    "postalCode": "23100",
    "streetAddress": "Sports eTech F.Z.E, SM Office –F1 104A, Ajman Free Zone Dubai"
  },
  "logo"  : "https://s3.ap-south-1.amazonaws.com/playo-website/venues-listing/sportstech-logo.png",
  "url"   :  "https://sportsetech.com/",
  "email": "contact(at)playo.co",
  "sameAs" : [
    "https://www.facebook.com/Playomiddleeast/",
    "https://www.instagram.com/playome/" , 
  ],
  "contactPoint" : [
    {
      "@type" : "ContactPoint",
      "telephone" : "+971507902152",
      "contactType" : "customer service",
      "areaServed" : "UAE"
    }
  ]
}`}
                    ]}
                />
        </span>
      )
    }

}

export default Seo;



// WEBPACK FOOTER //
// ./src/components/SeoPage/seoPage.js